













import { Component, Vue } from "vue-property-decorator";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerEntity } from "@/models/partnerEntity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";

@Component
export default class ThePartnerList extends Vue {
  loading = false;
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  set partner(partner: PartnerEntity) {
    PartnerModule.setPartner(partner);
    this.$router.push({ name: "PartnerDashboard", params: { partnerId: partner._id } });
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partners() {
    return PartnerModule.partners;
  }

  get name() {
    return PartnerModule.partner.companyName;
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  get items() {
    return [
      {
        icon: "mdi-view-dashboard-outline",
        text: "Übersicht",
        link: `/partners/${this.partnerId}/home`
      },
      {
        icon: "mdi-car-outline",
        text: "Schadensmeldungen",
        link: `/partners/${this.partnerId}/report`
      },
      {
        icon: "mdi-email-multiple-outline",
        text: "Landingpage",
        link: `/partners/${this.partnerId}/form`
      }
    ];
  }
}
